module.exports = "./assets/assets/验收模板及流程.992112ad.docx";